//when an img is wrapped in a link that has a title tag, append this title tag as a figure caption
document.querySelectorAll('article.blog a[title]').forEach((element) => {
  if (element.querySelector('img')) {
    const title = element.getAttribute('title')
    const span = document.createElement('div')
    span.className = 'img-caption'
    if (title.includes('|')) {
      span.innerHTML = `${title.split('|')[0].trim()} | <span>${title
        .split('|')[1]
        .trim()}</span>`
    } else {
      span.innerHTML = `<span>${title}</span>`
    }
    element.append(span)
  }
})
